import { CONFIDENCE_CLOUD_WAREHOUSE } from '@spotify/confidence-graphql';

export const isConfidenceCloudWarehouse = (
  warehouseName: string | null | undefined,
): boolean => warehouseName === CONFIDENCE_CLOUD_WAREHOUSE;
